import { IRevenueAgencyFakeTypeLang } from '../../../types/lang'
import { ERevenueAgencyFakeType } from '../../../types'

export const revenueAgencyFakeTypeLang: IRevenueAgencyFakeTypeLang = {
	revenue_agency_fake_type: {
		[ERevenueAgencyFakeType.None]: 'None_ua',
		[ERevenueAgencyFakeType.AccountFB]: 'AccountFB_ua',
		[ERevenueAgencyFakeType.Creo]: 'Creo_ua',
		[ERevenueAgencyFakeType.Installs]: 'Installs_ua',
		[ERevenueAgencyFakeType.Slices]: 'Slices_ua'
	}
}